import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-brand-bg text-brand-ink" data-testid="privacy-page">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-brand-muted hover:text-brand-ink mb-6"
          >
            <ArrowLeft size={14} /> Back to home
          </Link>

          <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight">
            Privacy Policy
          </h1>
          <p className="mt-2 text-sm text-brand-muted">Last updated: 29 April 2026</p>

          <div className="mt-10 prose prose-sm sm:prose-base max-w-none text-brand-ink leading-relaxed space-y-6">
            <section>
              <h2 className="font-heading text-xl font-semibold mt-0">1. Who we are</h2>
              <p className="text-brand-muted">
                Career Connect (“we”, “our”, “us”) is an HR consultancy founded in 2026
                and based in Parvati, Pune – 411009, Maharashtra, India. We help
                companies hire talent and help candidates find the right roles. This
                Privacy Policy explains how we collect, use, share and protect the
                personal information of visitors to our website and people who engage
                with our services.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">2. Information we collect</h2>
              <ul className="list-disc pl-6 text-brand-muted space-y-1">
                <li>
                  <strong>Contact information</strong> you submit via our forms — name,
                  email, phone, company, message, type of inquiry.
                </li>
                <li>
                  <strong>Candidate information</strong> when you engage our CV / interview
                  prep / career guidance services — CV content, work history, education,
                  preferences.
                </li>
                <li>
                  <strong>Client information</strong> shared by hiring companies — role
                  requirements, JD, hiring contacts, budget bands.
                </li>
                <li>
                  <strong>Technical data</strong> automatically logged when you visit the
                  site — IP address, browser, pages viewed, basic analytics.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">3. How we use information</h2>
              <ul className="list-disc pl-6 text-brand-muted space-y-1">
                <li>To respond to your inquiry and provide the services you request.</li>
                <li>To match candidates with relevant openings and vice versa.</li>
                <li>To improve our site, services and communication.</li>
                <li>To comply with applicable laws and prevent misuse of our services.</li>
              </ul>
              <p className="text-brand-muted">
                We do not sell your personal data. We share candidate profiles with
                hiring companies only with the candidate’s consent.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">4. Data retention</h2>
              <p className="text-brand-muted">
                We retain personal information only as long as needed for the purposes
                described above or as required by law. You can request deletion of your
                data at any time by writing to us at the email below.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">5. Your rights (DPDP Act, 2023)</h2>
              <p className="text-brand-muted">
                As per the Digital Personal Data Protection Act, 2023, you have the
                right to access, correct, update or delete your personal data, and the
                right to withdraw consent at any time.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">6. Cookies & analytics</h2>
              <p className="text-brand-muted">
                Our site may use basic cookies and analytics tools to understand traffic
                and improve user experience. You can disable cookies in your browser
                settings.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">7. Third-party services</h2>
              <p className="text-brand-muted">
                We use trusted third-party services (e.g., for form submissions, email
                delivery, hosting). These providers process data only on our
                instructions and under appropriate safeguards.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">8. Security</h2>
              <p className="text-brand-muted">
                We follow reasonable security practices to protect personal data. No
                online service is 100% secure, but we work to keep your information
                safe.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">9. Updates to this policy</h2>
              <p className="text-brand-muted">
                We may update this Privacy Policy from time to time. Material changes
                will be highlighted on this page with a revised “Last updated” date.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-semibold">10. Contact us</h2>
              <p className="text-brand-muted">
                Questions or requests about your data? Reach out at:
                <br />
                <strong>Career Connect</strong>
                <br />
                Founder: Priyanka Khasnis
                <br />
                Parvati, Pune – 411009, Maharashtra, India
                <br />
                Email:{" "}
                <a
                  className="text-brand-primary underline"
                  href="mailto:hiring.careerconnect@gmail.com"
                >
                  hiring.careerconnect@gmail.com
                </a>
                <br />
                Phone:{" "}
                <a className="text-brand-primary underline" href="tel:+917774805226">
                  +91 77748 05226
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
